import styled from 'styled-components'
import { SIZES } from '../../../../constants'

export default styled.input`
  border: 1px solid ${props => props.theme.header.search.form.input.borderColor};
  border-radius: 0;
  border-right: 0;
  color: ${props => props.theme.header.search.form.input.color};
  font-size: 13px;
  height: 40px;
  line-height: 28px;
  padding: 0 8px;
  width: 100%;

  &:focus {
    border-color: ${props => props.theme.header.search.form.input.borderColorFocus};
    outline: 0;
  }

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    height: 30px;
  }

  @media screen and (max-width: 800px) and (-ms-high-contrast: active), screen and (max-width: 800px) and (-ms-high-contrast: none) {
    margin-bottom: 10px;
  }
`
